import { useEffect, useRef } from "react";
import useModalStackStore from "stores/useModalStackStore";
import { Util } from "utils";

export const useEscKeyCloseInModal = (
  ref: React.MutableRefObject<any>,
  onClose: () => void
) => {
  const { addModal, removeModal, getTopModal } = useModalStackStore();

  const escEvent = (e: KeyboardEvent) => {
    /** 최상위 모달이 현재 모달일 때만 esc 로 닫히게 */
    if (getTopModal() !== ref) {
      return false;
    }
    Util.handleKeyPress(e, "Escape", onClose);
  };

  useEffect(() => {
    addModal(ref);
    const onPressESCKeyCheck = (event: KeyboardEvent) => {
      escEvent(event);
    };

    document.addEventListener("keydown", onPressESCKeyCheck);
    return () => {
      document.removeEventListener("keydown", onPressESCKeyCheck);
      removeModal(ref);
    };
  }, []);
};
